import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  box: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'relative',
  },
  counterBtn: {
    display: 'flex',
    color: theme.primary.p2,
    borderRadius: 4,
    height: 48,
    maxWidth: 181,
    gap: '16px',
    justifyContent: 'space-between',
    alignItems: 'center',

    '&:disabled': {
      pointerEvents: 'none',
      opacity: 0.54,

      '& svg path': {
        opacity: 0.54,
      },
    },

    '@media (max-width: 860px)': {
      maxWidth: 129,
    },

    '@media (max-width: 600px)': {
      maxWidth: 'unset',
      width: '100%',
    },
  },
  suffixWrap: {
    gap: '0',
  },
  input: {
    display: 'flex',
    alignItems: 'center',
    background: 'transparent',
    height: 24,
    width: 42,
    position: 'relative',

    '& input': {
      boxSizing: 'border-box',
      padding: 0,
      fontSize: 16,
      fontWeight: 600,
      height: 24,
      width: 50,
      color: theme.primary.p3,
      textAlign: 'center',
      caretColor: theme.primary.p3,
      background: 'transparent',
      border: 'none',
      lineHeight: '20px',
      position: 'relative',
    },
  },
  suffixInput: {
    marginLeft: '9px',
    marginRight: 28,
  },
  suffix: {
    fontSize: 16,
    fontWeight: 600,
    color: theme.primary.p3,
  },
  icon: {
    width: '24px',
    height: '24px',
  },
}));

export default useStyles;
